import * as React from "react";
import FormContainer from "../../layout/FormContainer/FormContainer";
import {observer} from "mobx-react";
import {RouteComponentProps} from "react-router";
import {FormComponent} from "../../state/FormsState";

interface IProps extends RouteComponentProps<any> {}

interface ILocalState {}

@observer
export default class FormSBAContainer  extends React.Component<
    IProps
    > {
    public state: ILocalState = {};

    public render() {
        return (<>
                <FormContainer initialComponent={FormComponent.SBAForm} {...this.props} />
            </>
        );
    }
}


// WEBPACK FOOTER //
// ./src/scenes/Forms/screens/FormSBA/FormSBAContainer.tsx